import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { FirebaseService } from '../services/firebase.service';
import { MatCard } from '@angular/material/card';
import { MatGridList } from '@angular/material/grid-list';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [NgbCarouselConfig] 
})
export class HomeComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.innerWidth=event.target.innerWidth;
    if(this.innerWidth >= 1120){
      this.cols=4;
    }
    else if(this.innerWidth >= 840){
      this.cols=3;
    }
    else if(this.innerWidth >= 600){
      this.cols=2
    }
    else {
      this.cols=1;
    }
  }

  cols:number;
  
  plans:Array<any>;

  innerWidth:any;


  constructor(private router:Router, carousel: NgbCarouselConfig, private fbs: FirebaseService) {
    this.innerWidth= window.innerWidth;
    if(this.innerWidth >= 1120){
      this.cols=4;
    }
    else if(this.innerWidth >= 840){
      this.cols=3;
    }
    else if(this.innerWidth >= 600){
      this.cols=2;
    }
    else {
      this.cols=1;
    }
    carousel.interval=5000;
    carousel.wrap=true;
    this.images=["../../assets/banners/purenet0.jpg", "../../assets/banners/purenet1.jpg", "../../assets/banners/purenet2.jpg", "../../assets/banners/purenet3.jpg", "../../assets/banners/purenet4.jpg", "../../assets/banners/purenet5.jpg"];
    this.fbs.getPlans().subscribe(res=>{
      this.plans=res;
    });
   }

  ngOnInit(): void {
    
  }

  
  selectPlan(planId){
    this.fbs.setSelectedPlan(planId);
    this.router.navigateByUrl('selected');
  }

  images: string[];

  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;

  @ViewChild('carousel', {static : true}) carousel: NgbCarousel;

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.unpauseOnArrow && slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }


}
